import { Role } from "common/types/user.type"

const filterRoles = Object.values(Role).filter(
  value => typeof value === "string" && value !== "Superadmin"
)

filterRoles.sort((roleA, roleB) => {
  return Role[roleB] - Role[roleA]
})

export { filterRoles }
